import * as runtypes from 'runtypes'
import { apiFetch } from './helpers'
import { VendorFragment } from '../model/fragments'

export const FetchProductRackVendorsRequest = runtypes.Record({
	lat: runtypes.Union(runtypes.Number, runtypes.Undefined),
	lng: runtypes.Union(runtypes.Number, runtypes.Undefined),
	productRackIds: runtypes.Array(runtypes.String)
})
export type FetchProductRackVendorsRequest = runtypes.Static<
	typeof FetchProductRackVendorsRequest
>

export const FetchProductRackVendorsResponseData = runtypes.Record({
	items: runtypes.Array(runtypes.Unknown.withConstraint<VendorFragment>(
		() => true,
	))
})
export type FetchProductRackVendorsResponseData = runtypes.Static<
	typeof FetchProductRackVendorsResponseData
>

export const fetchProductRackVendors = async (values: FetchProductRackVendorsRequest) => {
	
	return apiFetch(
		FetchProductRackVendorsResponseData,
		'/api/fetchProductRackVendors',
		values,
	)
}
